(function() {
  'use strict';

  angular
    .module('sempraWebapp')
    .directive('errorContainer',  errorContainerInject);

  /** @ngInject */
  function errorContainerInject(errorActions) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/errorContainer/errorContainer.html',
      controller: ErrorContainerController,
      controllerAs: 'vm',
      scope : {},
      replace: true,
      bindToController : {
        errorHeader : '=',
        errorName : '=',
        errorDescription : '='
      }
    };

    return directive;

    /** @ngInject */
    function ErrorContainerController() {
      var vm = this;

      vm.closeErrorBox = function(){
        errorActions.acknowledgeErrorMsg();
      }

    }
  }

})();
